import * as React from "react";

export interface ThemifiedComponents {
  isToBusiness?: boolean;
}

export const BusinessContext = React.createContext<ThemifiedComponents>({});

export const ThemifiedConsumer = BusinessContext.Consumer;
